import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/worker/$workerCode")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-gray-600">Please use the actual clock-in link sent via SMS</p>
      </div>
    </div>
  );
}

